import { Box, Button, ButtonSize } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const FooterButtonStyled = styled(Button).attrs({
  size: ButtonSize.SMALL,
})`
  ${({ theme }) => css`
    margin-left: 10px;
    min-width: 96px;
    font-weight: ${theme.fontWeights[600]};
    padding: ${theme.spacings[500]};
  `}
`;

export const ModalHeaderContainerStyled = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  width: 100%;
  ${({ theme }) => css`
    padding: ${theme.spacings[300]};
  `}
`;
